export const ChargerTypes = {
  EASEE: "easeeCircuit",
  ZAPTEC: "zaptecInstallation",
  ALFEN: "alfenSCN",
  ALPITRONIC: "alpitronicHypercharger",
  ALFEN_SOCKET: "alfenSocket",
  TECHNAGON_AC: "technagonAC",
  AUTEL: "autel",
  DEFA: "defa",
  NEXBLUE: "nexBlue",
  SUPERNOVA: "supernova",
  KEMPOWER: "kempower",
};

export const StepTypes = {
  RATIO: "ratio",
  ABSOLUTE: "absolute"
};

export const evChargerTemplate = {
  [ChargerTypes.ALFEN]: {
    name: "",
    ip: "",
    minCurrent: 20,
    decrease: {type: "ratio", value: 0.8},
    increase: {type: "absolut", value: 16},
  },
  [ChargerTypes.EASEE]: {
    name: "",
    siteId: "",
    circuitId: "",
    minCurrent: 20,
    credentials: {username: "", password: ""},
    decrease: {type: "ratio", value: 0.8},
    increase: {type: "absolut", value: 16},
  },
  [ChargerTypes.ZAPTEC]: {
    name: "",
    installationId: "",
    minCurrent: 32,
    credentials: {username: "", password: ""},
    decrease: {type: "ratio", value: 0.8},
    increase: {type: "absolut", value: 16},
  },
  [ChargerTypes.ALPITRONIC]: {
    name: "",
    ip: "",
    minPowerW: 30000,
    decrease: {type: "ratio", value: 0.8},
    increase: {type: "absolut", value: 16},
  },
  [ChargerTypes.SUPERNOVA]: {
    name: "",
    ip: "",
    minPowerW: 30000,
    decrease: {type: "ratio", value: 0.8},
    increase: {type: "absolut", value: 16},
  },
  [ChargerTypes.ALFEN_SOCKET]: {
    name: "",
    ip: "",
    port: 502,
    socketId: 1,
    minCurrent: 16,
    decrease: {type: "absolut", value: 4},
    increase: {type: "absolut", value: 4},
  },
  [ChargerTypes.AUTEL]: {
    name: "",
    ip: "",
    port: 502,
    socketId: 1,
    minCurrent: 16,
    decrease: {type: "absolut", value: 4},
    increase: {type: "absolut", value: 4},
  },
  [ChargerTypes.DEFA]: {
    name: "",
    ip: "",
    port: 502,
    minCurrent: 16,
    offlineTimeout: 0,
    offlinePowerA: 0,
    decrease: {type: "absolut", value: 4},
    increase: {type: "absolut", value: 4},
  },
  [ChargerTypes.NEXBLUE]: {
    name: "",
    ip: "",
    port: 502,
    modbusId: 200,
    minCurrent: 6,
    offlineTimeout: 300,
    offlinePowerA: 6,
    decrease: {type: "absolut", value: 4},
    increase: {type: "absolut", value: 4},
  },
  [ChargerTypes.TECHNAGON_AC]: {
    name: "",
    ip: "",
    port: 502,
    socketId: 1,
    minCurrent: 16,
    decrease: {type: "absolut", value: 4},
    increase: {type: "absolut", value: 4},
  },
  [ChargerTypes.KEMPOWER]: {
    name: "",
    ip: "",
    port: 502,
    modbusId: 1,
    minPowerW: 30000,
    offlineTimeout: 90,
    offlinePower: 10000,
    decrease: {type: "ratio", value: 0.9},
    increase: {type: "absolut", value: 20000},
  },
};

